<!--
Author: TangChen
Date: 2018-09-12
Desc: 获取图形验证码弹框，为公共组件
 -->
<template>
    <div class="comp-verifycode-check comp">
        <el-dialog
            title=""
            :visible.sync="visible"
            width="405px"
            class="prop"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            v-on:close="dialogClose"
        >
            <el-form ref="form" :model="form" :rules="ruleVerify" v-on:submit.native.prevent>
                <el-form-item label="">
                    <p class="prop-text">您的手机号码：{{ mobile }}</p>
                </el-form-item>
                <el-form-item label="手机验证码：" prop="verifycode">
                    <el-input
                        v-model.trim="form.verifycode"
                        class="img-code"
                        placeholder="请输入手机验证码"
                        :maxlength="6"
                    />
                </el-form-item>
            </el-form>
            <el-form slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="submitForm('form')">确 定</el-button>
                <el-button v-on:click="dialogClose">取 消</el-button>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "VerifycodeCheck",
    props: {
        dialogVisible: {
            type: Boolean,
            required: true
        },
        mobile: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            form: {
                verifycode: ""
            },
            visible: false, // 是否显示dialog
            ruleVerify: {
                // 验证码校验
                verifycode: [{ validator: this.$util.validateVerifyCode, trigger: "blur" }]
            }
        };
    },
    watch: {
        dialogVisible(val) {
            this.visible = val;
            if (!val) {
                this.$refs["form"].resetFields();
            }
        }
    },
    methods: {
        /* 提交表单数据 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit("verify-in", this.form.verifycode);
                } else {
                    this.$errorScroll();
                }
            });
        },
        dialogClose() {
            this.$emit("verify-in");
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-verifycode-check {
    .el-form-item__label {
        padding-right: 0;
    }
}
</style>
